const DeliveryNote = {

    // FIELDS
    "receiver_name": "اسم المستلم",
    "delivery_date": "تاريخ التسليم",
    "document": "مستند",
    "search": "بحث",
    "delivered_date": "تاريخ التسليم",
    "item": "عنصر",
    "rate": "معدل",
    "quantity": "كمية",
    "unit": "وحدة",
    "sub_total": "المجموع الفرعي",
    "discount": "خصم",
    "vat": "ضريبة القيمة المضافة",
    "total": "المجموع",

    // PAGE HEADER
    "delivery_note": "إشعار التسليم",

    // TOOLTIP
    "pod": "جراب",

    // ERROR
    "error_delivery_date": "اختر التاريخ",
    "error_receiver_name": "أدخل اسم المستلم",

    // TABLE HEADER
    "table_dn_code": "شفرة DN",
    "table_da_code": "رمز DA",
    "table_booking_date": "تاريخ الحجز",
    "table_delivery_date": "تاريخ التسليم",
    "table_delivered_date": "تاريخ التسليم",
    "table_customer": "العميل",
    "table_receiver": "المستلم",
    "table_status": "الحالة",
}

export default DeliveryNote;